/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Examplecompanylimitedliabilitycompany4Inputs */

const en_examplecompanylimitedliabilitycompany4 = /** @type {(inputs: Examplecompanylimitedliabilitycompany4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Example Company Limited Liability Company`)
};

const de_examplecompanylimitedliabilitycompany4 = /** @type {(inputs: Examplecompanylimitedliabilitycompany4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beispiel: Gesellschaft mit beschränkter Haftung`)
};

/**
* | output |
* | --- |
* | "Example Company Limited Liability Company" |
*
* @param {Examplecompanylimitedliabilitycompany4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const examplecompanylimitedliabilitycompany4 = /** @type {((inputs?: Examplecompanylimitedliabilitycompany4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Examplecompanylimitedliabilitycompany4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_examplecompanylimitedliabilitycompany4(inputs)
	return de_examplecompanylimitedliabilitycompany4(inputs)
});
export { examplecompanylimitedliabilitycompany4 as "exampleCompanyLimitedLiabilityCompany" }